import axios from "axios";
const baseURL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("authToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleAuthRedirect();
    }
    
    if (
      error.response?.status === 404 && 
      error.response?.data?.msg?.includes("Attempt to read property")
    ) {
      handleAuthRedirect();
    }
    
    if (
      error.response?.data?.result === null && 
      error.response?.data?.msg?.includes("Attempt to read property")
    ) {
      handleAuthRedirect();
    }
    
    if (error.response?.status === 403) {
      handleAuthRedirect();
    }

        if (error.response?.status === 500) {
      handleAuthRedirect();
    }

    return Promise.reject(error);
  }
);

export const handleAuthRedirect = () => {
  const currentPath = window.location.pathname;
  sessionStorage.setItem("redirectAfterLogin", currentPath);

  localStorage.clear();
  sessionStorage.removeItem("authToken");
  sessionStorage.removeItem("userData");

  window.location.href = "/login";
};

export default api;